import React from 'react'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import SobreNosotros from './components/SobreNosotros'
import Trabajos from './components/Trabajos'
import Contacto from './components/Contacto'

function App() {
  return (
    <Router>
      <Navbar />
      <main className="min-h-screen bg-gray-100">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/sobre" element={<SobreNosotros />} />
          <Route path="/trabajos" element={<Trabajos />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
      </main>
    </Router>
  )
}

export default App